import { DEFAULT_BREAK_POINTS } from "../common/constant";
import { CnPageColumnChange, emitEvent } from "../../../common/util/event-name";
import { defaultContext } from "../common/context";
import debounce from 'lodash/debounce';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';

/**
 * 获取当前屏幕断点
 * @param breakPoints
 */
export function getCurBreakPoint(breakPoints) {
  var screenWidths = [];
  var tmpMap = {};
  var availWidth = document.body.clientWidth;
  breakPoints.forEach(function (bp) {
    var width = bp.width;
    screenWidths.push(width);
    tmpMap[width] = bp;
  });
  screenWidths = screenWidths.sort(function (a, b) {
    return a - b;
  });
  var len = screenWidths.length;
  var ret = tmpMap[screenWidths[0]];
  if (availWidth > screenWidths[len - 1]) {
    ret = tmpMap[screenWidths[len - 1]];
  } else {
    for (var i = 1; i < len; i++) {
      var breakPoint = tmpMap[screenWidths[i]];
      if (screenWidths[i - 1] <= availWidth && availWidth < screenWidths[i]) {
        ret = breakPoint;
      }
    }
  }
  return ret;
}

/**
 * 获取最大断点列数
 */
export function getMaxNumberOfColumns(breakPoints) {
  if (breakPoints === void 0) {
    breakPoints = DEFAULT_BREAK_POINTS;
  }
  var screenWidths = breakPoints.map(function (bp) {
    return bp.width;
  });
  var maxWidth = Math.max.apply(Math, screenWidths);
  var bp = breakPoints.find(function (breakPoint) {
    return (breakPoint === null || breakPoint === void 0 ? void 0 : breakPoint.width) === maxWidth;
  });
  return (bp === null || bp === void 0 ? void 0 : bp.numberOfColumns) || 12;
}

/**
 * 是否为标准的预设尺寸
 * @param val
 */
export function isPresetSize(val) {
  return ['small', 'medium', 'large'].indexOf(val) > -1;
}

/**
 * 为数值包裹自动单位
 * eg:
 *  wrapUnit(2) -> 2px
 *  wrapUnit('2em') -> 2em
 * @param value
 * @param unit
 */
export function wrapUnit(value, unit) {
  if (unit === void 0) {
    unit = 'px';
  }
  return isNumber(value) ? "" + value + unit : value;
}

/**
 * 是否为一个有效的 gap 值:
 * eg: 0.9 / -9px / auto
 * @param val
 */
export function isValidGap(val) {
  var gapValReg = /^-?[0-9]*\.?[0-9]+([a-z|A-z]*)$/;
  return isNumber(val) || isString(val) && (gapValReg.test(val) || val === 'auto');
}

/**
 * 获取最终的 gap 值
 * @param contextGap 上下文中的 gap 值
 * @param propGap 属性中定义的 gap 值
 */
export function getGapVal(contextGap, propGap) {
  if (isValidGap(propGap)) {
    return wrapUnit(propGap);
  } else if (isValidGap(contextGap)) {
    return wrapUnit(contextGap);
  }
  return undefined;
}
function calPageClassNames(config) {
  var bp = getCurBreakPoint(DEFAULT_BREAK_POINTS);
  // const pageContainer = document.getElementById('cn-ui-page-scroll-container')
  var body = document.body;
  if (body) {
    var cls = body === null || body === void 0 ? void 0 : body.className;
    if (typeof bp.numberOfColumns === 'number') {
      var _cls$match, _cls$match$call, _cls$match$call$;
      var prefix = defaultContext.prefix + "page--col-";
      var index = cls === null || cls === void 0 ? void 0 : cls.indexOf(prefix);
      var pattern = /(cn-layout-page--col-)\d+/;
      var currentNumberOfColumn = +(cls === null || cls === void 0 ? void 0 : (_cls$match = cls.match) === null || _cls$match === void 0 ? void 0 : (_cls$match$call = _cls$match.call(cls, pattern)) === null || _cls$match$call === void 0 ? void 0 : (_cls$match$call$ = _cls$match$call[0]) === null || _cls$match$call$ === void 0 ? void 0 : _cls$match$call$.replace(prefix, ''));
      if (index !== -1) {
        if (currentNumberOfColumn !== bp.numberOfColumns) {
          body.className = cls === null || cls === void 0 ? void 0 : cls.replace(pattern, "" + prefix + bp.numberOfColumns);
        }
        emitEvent(CnPageColumnChange, bp);
      } else {
        body.className = cls + " " + prefix + bp.numberOfColumns;
        emitEvent(CnPageColumnChange, bp);
      }
    }
  }
}
export var debounceCalPageClassNames = debounce(function (config) {
  calPageClassNames === null || calPageClassNames === void 0 ? void 0 : calPageClassNames(config);
}, 500, {
  leading: true
});
export var debounceCalPageClassNames2 = debounce(function (config) {
  calPageClassNames === null || calPageClassNames === void 0 ? void 0 : calPageClassNames(config);
}, 500, {
  leading: true
});